export default __webpack_public_path__ + "static/media/profile1-active.3d744e57.svg";